import React,{useState,useRef} from 'react'
import { getVanPayfortUrl } from '../../actions/VanSubscription';


const VanSubsAmazonPay = ({paymentConfig,userDetail,subsFeeDetail}) => {
  const {id} = userDetail !==undefined && userDetail
  const formRef = useRef(null);
    const [loading,setLoading] = useState(false)
    const [formStateData,setFormStateData] = useState();
  const {requestParams} = formStateData !==undefined && formStateData
  
    const AmazonButtonHandle = () => {
      setLoading(true)
      const data = {
        student_id: id,
        amount:subsFeeDetail?.amount,
        gateway_id: paymentConfig.id,
        id:subsFeeDetail?.id,
        fee_type:subsFeeDetail?.pay_type,
        subscription_type:subsFeeDetail?.subscription_type,
        subscriptions_id:subsFeeDetail?.subscriptions_id,
        success_url:`${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/success`,
        failure_url:`${process.env.REACT_APP_PUBLIC_URL}/student/checkpaymentstatus/failure`,
      }

      getVanPayfortUrl(data).then((res) => {
          setLoading(true)
          if(res.status){
              setLoading(false)
              setFormStateData(res)
            }
      })
  }

  if (formStateData !==undefined) {
    setTimeout(() => { formRef.current.submit(); }, 1000)
  }

  return (
    <div>
    {loading ? <button type="submit" disabled className="banktransfer_btn">
            <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
            Processing ...</button> : 
            <>
       <button onClick={AmazonButtonHandle}
       className='banktransfer_btn'>Amazon payment services</button>

    </>
    }
              {formStateData &&  
              <form ref={formRef}
                    method="POST"
                    name="redirect"
                    action={`${formStateData?.url}`}
                    >
                    
                   {Object.keys(requestParams !==undefined && requestParams).map((key, index) => (
                      <input
                        key={index}
                        type="hidden"
                        name={key}
                        value={requestParams[key]}
                        readOnly
                      />
                    ))}
                </form>
                }
    </div>
  )
}

export default VanSubsAmazonPay